module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-report@2x-f43f4355b5c066f0f7de670c294e12c5.png";